module.exports = __webpack_public_path__ + "img/koe4-3.c6ed91ba.jpg";